<template>
  <div>
    <v-app>
      <resizable-page>
        <template v-slot:table="tableProps">
          <v-card>
            <v-card-title>
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Export To XLS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('all');
                        }
                      "
                    >
                      All Record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item>
                    <downloadExcel
                      class="btn"
                      :data="exportDisplayedPage"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                    >
                      Displayed record
                    </downloadExcel>
                  </v-list-item>
                  <v-list-item>
                    <downloadExcel
                      class="btn"
                      :fields="field_export"
                      :worksheet="worksheetName"
                      :name="fileName"
                      :fetch="
                        () => {
                          return dataExportBefore('filter');
                        }
                      "
                    >
                      All filtered record
                    </downloadExcel>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>
              <div class="d-flex">
                <v-select
                  style=" max-width: 150px;"
                  :items="option_filter"
                  label="Select"
                  v-model="searchCategory"
                  @change="search = ''"
                  item-text="text"
                  item-value="value"
                  class="ma-2"
                  hide-details
                >
                </v-select>
                <v-text-field
                  :disabled="!searchCategory"
                  v-model="search"
                  label="Search"
                  class="ma-2"
                  single-line
                  hide-details
                >
                </v-text-field>
                <v-btn
                  :disabled="!search"
                  class="mt-5"
                  small
                  color="primary"
                  @click="searchButton"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  v-if="searchValue"
                  class="mt-5 ml-1"
                  dark
                  small
                  color="red"
                  @click="clearSearchButton"
                  >Clear</v-btn
                >
              </div>
            </v-card-title>

            <v-data-table
              mobile-breakpoint
              :headers="headers"
              :items="table"
              :loading="loadTable"
              loading-text="Loading... Please wait"
              @current-items="getFiltered"
              ref="vTable"
              :height="tableProps.tableHeight"
              fixed-header
              :options.sync="options"
              :server-items-length="totalDataTable"
              :page="page"
              :pageCount="numberOfPages"
              :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }"
            >
           

            
              


              <template v-slot:[`header.pool`]="{ header }">
                  <v-select
                    style=" font-size:10px;"
                    :items="optionPool"
                    :label="header.text"
                    v-model="valuePool"
                    @change="getList"
                    item-text="text"
                    item-value="value"
                    class="ma-2"
                    hide-details
                  >
                  </v-select>
                </template>
                
                <template v-slot:[`item.faktur_total_biaya_jasa`]="{ item }">
                  <span style="text-align:right;">Rp.
                  {{ formatPrice(item.faktur_total_biaya_jasa)}}</span>
                </template>
                <template v-slot:[`item.faktur_total_biaya_spare_part`]="{ item }">
                  <span style="text-align:right;">Rp.
                  {{ formatPrice(item.faktur_total_biaya_spare_part)}}</span>
                </template>
      
      <template v-slot:[`item.pool`]="{ item }">
    
        <span >{{ item.faktur_pkb.service_estimate.pool.pool_name}} </span>
          
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        
          <v-menu  offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              x-small
              v-bind="attrs"
              v-on="on"
              
            >
              <v-icon dark x-small>
                mdi-format-list-bulleted-square
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="detailFaktur(item.id)">
              <v-list-item-title >Detail</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
            </v-data-table>
          </v-card>
        </template>
      </resizable-page>
    </v-app>
    <modal ref="modalDetailPage">
      <template v-slot:body >
        <detail-faktur :data_id="$refs.modalDetailPage.data" />
      </template>
    </modal>
  </div>
</template>

<script>
 import vuetify from '@/plugins/vuetify'
  import JsonExcel from "vue-json-excel";
  import { ResizablePage } from "@/components";
  import DetailFaktur from "@/pages/Dashboard/Workshop/Faktur/DetailFaktur.vue";
  import { Modal } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage, Modal, "detail-faktur":DetailFaktur
  },
  vuetify,
  data() {
    return {
      user: null,
      searchValue: null,
      searchCategory: null,
      option_filter: [
        { text: "Invoice No.", value: "faktur_no" },
        { text: "PKB No.", value: "pkb_no" },
        { text: 'Customer Name', value: 'client_name'},
        { text: 'Customer Phone', value: 'client_phone' },
        { text: "Plat No", value: "plat_no" },
      ],
      page: 1,
      totalDataTable: 0,
      numberOfPages: 0,
      loadTable: true,
      role: "",
      search: "",
      options: {},
      headers: [
          {
            text: 'Actions',
            align: 'start center',
            value: 'actions',
            sortable: false
          },
          { text: 'Invoice No.', value: 'faktur_no' },
          { text: 'Invoice Date', value: 'faktur_invoice_datetime', width:'120' },
          { text: 'PKB No.', value: 'faktur_pkb.pkb_no' },
          { text: 'Customer Name', value: 'faktur_pkb.service_estimate.client.client_name', width:'200' },
          { text: 'Plate No.', value: 'faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no' },
          { text: 'Total Jasa', value: 'faktur_total_biaya_jasa', width:'150' },
          { text: 'Total Spare Part', value: 'faktur_total_biaya_spare_part', width:'150' },
          { text: 'SA Contact', value: 'faktur_sa_contact' },
          { text: 'Created At', value: 'created_at', align: 'center', width:'200'},
        ],
      table: [],
      
      worksheetName: "Faktur",
      fileName:"Faktur.xls",
      exportDisplayedPage: [],
      exportAllFitered: [],
      exportAll: [],
      field_export: {
          'no' : 'no',
          'faktur_no' : 'faktur_no',
          'faktur_invoice_datetime' : 'faktur_invoice_datetime',
          'pkb_no' : 'faktur_pkb.pkb_no',
                    'client_name' : 'faktur_pkb.service_estimate.client.client_name',
                    'client_phone' : 'faktur_pkb.service_estimate.client.client_phone',
                    'client_email' : 'faktur_pkb.service_estimate.client.client_email',
                    'client_address' : 'faktur_pkb.service_estimate.client.client_address',
                    'vehicle_brand_name' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_brands.vehicle_brand_name',
                    'vehicle_type' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_model',
                    'vehicle_year_model' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_types.vehicle_year_model',
                    'vehicle_plate_no' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no',
                    'vehicle_chasis_no' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_chassis_no',
                    'vehicle_engine_no' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_engine_no',
                    'vehicle_body_color' : 'body_color',
                    'vehicle_production_year' : 'faktur_pkb.service_estimate.vehicle_types.vehicle_production_year',
                    'km_in' : 'faktur_pkb.service_estimate.service_estimate_vehicle_km',
                    'km_out' : 'faktur_customer_km_out',
                    'faktur_date_in' : 'faktur_date_in',
                    'faktur_date_out' : 'faktur_date_out',
                    'faktur_total_biaya_jasa' : 'faktur_total_biaya_jasa',
                    'faktur_total_biaya_spare_part' : 'faktur_total_biaya_spare_part',
                    'faktur_ppn' : 'faktur_ppn',
                    'faktur_materai' : 'faktur_materai',
                    'faktur_ketentuan' : 'faktur_ketentuan',
                    'faktur_saran' : 'faktur_saran',
                    'faktur_kasir' : 'faktur_kasir',
          created_at: "created_at",
          updated_at: "updated_at",
        },
      
      optionPool: [
            { text: "All", value: "" },
          ],
          valuePool: "",
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.mounted) {
          this.getList();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    console.log(this.$route);
     //set refs in root saat page terbuka, agar fungsi di page ini bisa di panggil dari page lain
      this.$root.$refs.ListPkbPage = this;
      //check saat page terbuka apakah ada params 
      if(this.$route.params.id){
       
        //open detail
        this.detailFaktur(this.$route.params.id)
      }
    //get list role dan permission current user
    this.role = await this.$store.getters["role_permission/route_filter"];

    this.user = await this.$store.getters["profile/me"];
      if(!this.user.pool){
        this.headers.push({ text: "Eshed", value: "pool", sortable: false, width:'120' });
        await this.$store.dispatch("workshop_pool/list");
        await this.$store.getters["workshop_pool/list"].forEach((value, index) => {
          this.optionPool.push({ text: value.pool_name, value:  value.id});
         });
      }
    this.getList();
    this.mounted = false;
  },
  methods: {
    // ambil data yang dibutuhkan
    async getList() {
      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      var query = { page: { number: pageNumber, size: itemsPerPage } };

      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
        if (query.filter) {
          Object.assign(query.filter, {
            [this.searchCategory]: this.searchValue,
          });
        } else {
          query.filter = { [this.searchCategory]: this.searchValue };
        }
      }

    

      if(this.valuePool!=''){
        if(query.filter){
          Object.assign(query.filter, {pool:this.valuePool});
        }
        else{
          query.filter = {pool:this.valuePool}
        }
      }
    

      await this.$store.dispatch("workshop_faktur/list", query);
      this.table = await this.$store.getters["workshop_faktur/list"];
      var pageMeta = await this.$store.getters["workshop_faktur/page"];
      console.log(pageMeta);
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },
    searchButton() {
      this.options.page = 1;
      this.searchValue = this.search;
      this.getList();
    },
    clearSearchButton() {
      this.options.page = 1;
      this.searchValue = null;
      this.search = null;
      this.searchCategory = null;
      this.getList();
    },

    getFiltered(data) {
      this.exportDisplayedPage = this.dataExport(data);
    },

    detailFaktur(id){
        this.$refs.modalDetailPage.openModal({id:id})
      },
      modalCloseDetail(){
        this.$refs.modalDetailPage.closeModal();
        this.getList();
  
      },
   
      formatPrice(value) {
      let val = (value / 1).toFixed().replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    async dataExportBefore(type) {
      if (this.table.length != 0) {
        if (type == "all") {
          await this.$store.dispatch("workshop_faktur/list");
          return this.dataExport(
            await this.$store.getters["workshop_faktur/list"]
          );
        } else if (type == "filter") {
          var query = {};

          if (this.searchValue && this.searchCategory) {
            if (query.filter) {
              Object.assign(query.filter, {
                [this.searchCategory]: this.searchValue,
              });
            } else {
              query.filter = { [this.searchCategory]: this.searchValue };
            }
          }

          await this.$store.dispatch("workshop_faktur/list", query);
          return this.dataExport(
            await this.$store.getters["workshop_faktur/list"]
          );
        }
      }
    },

    bodyColor($bodyColorCode ){
      if($bodyColorCode == 0){
                return  "Putih";
                        }
                        else if($bodyColorCode == 1){
                          return  "Putih Kuning";
                        }
                        else if($bodyColorCode == 2){
                          return  "Putih Metalik";
                        }
                        else if($bodyColorCode == 3){
                          return  "Hitam";
                        }
                        else if($bodyColorCode == 4){
                          return  "Hitam Metalik";
                        }
                        else if($bodyColorCode == 5){
                         return  'Silver';
                        }
                        else if($bodyColorCode == 6){
                          return  "Silver Metalik";
                        }
                        else if($bodyColorCode == 7){
                          return  "Abu Abu";
                        }
                        else if($bodyColorCode == 8){
                          return  "Abu Abu Metalik";
                        }
                        else if($bodyColorCode == 9){
                          return  "N/A";
                        }
    },
  
    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
//     dataExport(data){
  
//   var dataRetrun = []
// data.forEach((value, index_1) => {
//     // console.log(value)
//     var client_phone= null
//     var client_name= null
//     var client_email= null
//     var client_address= null
//     var pkb= null
//     var vehicle_no_plat= null
//     var vehicle_colour= null
//     var vehicle_production_year= null
//     var vehicle_engine_no= null
//     var vehicle_chassis_no= null

//     if(value.faktur_pkb.service_estimate.vehicle_types){
//       vehicle_no_plat = value.faktur_pkb.service_estimate.vehicle_types.vehicle_plate_no
//       vehicle_engine_no = value.faktur_pkb.service_estimate.vehicle_types.vehicle_engine_no
//       vehicle_chassis_no = value.faktur_pkb.service_estimate.vehicle_types.vehicle_chassis_no
//       if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 0){
//           vehicle_colour = "Putih"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 1){
//           vehicle_colour = "Putih Kuning"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 2){
//           vehicle_colour = "Putih Metalik"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 3){
//           vehicle_colour = "Hitam"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 4){
//           vehicle_colour = "Hitam Metalik"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 5){
//           vehicle_colour = "Silver"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 6){
//           vehicle_colour = "Silver Metalik"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 7){
//           vehicle_colour = "Abu Abu"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 8){
//           vehicle_colour = "Abu Abu Metalik"
//         }
//         else if(value.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color == 9){
//           vehicle_colour = "N/A"
//         }

//       vehicle_production_year = value.faktur_pkb.service_estimate.vehicle_types.vehicle_production_year
//     }

//     if(value.faktur_pkb){
//       pkb = value.faktur_pkb.pkb_no
//     }
//     if(value.nota_part_client){
//       client_phone = value.nota_part_client.client_phone1
//       client_name = value.nota_part_client.client_name1
//       client_email = value.nota_part_client.client_email1
//       client_address =value.nota_part_client.client_address1
//     }

//     var data= {
//           'no': no,
//           'nota_jasa_bkl_no' : value.nota_jasa_bkl_no,
//           'nota_jasa_bkl_datetime' : value.nota_jasa_bkl_datetime,
//           'pkb_no' : value.faktur_pkb.pkb_no,
//           'pkb_datetime' : value.faktur_pkb.pkb_datetime,
//           'client_name' : value.faktur_pkb.service_estimate.client.client_name,
//           'client_phone' : value.faktur_pkb.service_estimate.client.client_phone,
//           'client_email' : value.faktur_pkb.service_estimate.client.client_email,
//           'client_address' : value.faktur_pkb.service_estimate.client.client_address,
//           'service_estimate_customer_plate_no' : vehicle_no_plat,
//           'service_estimate_chasis_no' : vehicle_chassis_no,
//           'service_estimate_engine_no' : vehicle_engine_no,
//           'service_estimate_customer_color' : vehicle_colour,
//           'service_estimate_customer_year' : vehicle_production_year,
//           'nota_jasa_bkl_mengetahui' : nota_jasa_bkl_mengetahui,
//           'nota_jasa_bkl_diperiksa' : nota_jasa_bkl_diperiksa_name,
//           'no_service' : index_2+1,
//           'service_master_code' : value_2.service_master_code,
//           'service_master_name' : value_2.service_master_name,
//           'service_master_lts' : value_2.service_master_lts,
//           'service_category_standard_cost' : value_2.service_category_standard_cost,
//           'service_estimate_service_discount' : value_2.pkb_service_discount,
//           'service_total' : Math.round((value_2.service_master_lts * value_2.service_category_standard_cost) - ((value_2.service_master_lts * value_2.service_category_standard_cost)* value_2.pkb_service_discount / 100)),
//           'created_at' :  value.created_at,
//           'updated_at' :  value.updated_at
//         }

//         var data= {
//         'no' : no,
//           'faktur_no' : faktur_no,
//           'faktur_invoice_datetime' : faktur_invoice_datetime,
//           'pkb_no' : faktur_pkb.pkb_no,
//                     'client_name' : 'faktur_pkb.service_estimate.client.client_name',
//                     'client_phone' : 'faktur_pkb.service_estimate.client.client_phone',
//                     'client_email' : 'faktur_pkb.service_estimate.client.client_email',
//                     'client_address' : 'faktur_pkb.service_estimate.client.client_address',
//                     'vehicle_brand_name' : 'faktur_vehicle.vehicle_brand_name',
//                     'vehicle_type' : 'faktur_vehicle.vehicle_type',
//                     'vehicle_year_model' : 'faktur_vehicle.vehicle_year_model',
//                     'service_estimate_customer_plate_no' : 'faktur_pkb.service_estimate.service_estimate_customer_plate_no',
//                     'service_estimate_chasis_no' : 'faktur_pkb.service_estimate.service_estimate_chasis_no',
//                     'service_estimate_engine_no' : 'faktur_pkb.service_estimate.service_estimate_engine_no',
//                     'service_estimate_customer_color' : 'faktur_pkb.service_estimate.service_estimate_customer_color',
//                     'service_estimate_customer_year' : 'faktur_pkb.service_estimate.service_estimate_customer_year',
//                     'km_in' : 'faktur_pkb.service_estimate.service_estimate_vehicle_km',
//                     'km_out' : 'faktur_customer_km_out',
//                     'faktur_date_in' : 'faktur_date_in',
//                     'faktur_date_out' : 'faktur_date_out',
//                     'faktur_total_biaya_jasa' : 'faktur_total_biaya_jasa',
//                     'faktur_total_biaya_spare_part' : 'faktur_total_biaya_spare_part',
//                     'faktur_ppn' : 'faktur_ppn',
//                     'faktur_materai' : 'faktur_materai',
//                     'faktur_ketentuan' : 'faktur_ketentuan',
//                     'faktur_saran' : 'faktur_saran',
//                     'faktur_kasir' : 'faktur_kasir',
//           'created_at': "created_at",
//           'updated_at': "updated_at",

//         }

//   });

 


//   console.log(dataRetrun)
//   return dataRetrun
// },

dataExport(data){
      return data = data.map((v,index) => ({...v, no: index+1, faktur_kasir: v.faktur_kasir_name.name, body_color: v.faktur_pkb.service_estimate.service_estimate_type==1?this.bodyColor(v.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color):v.faktur_pkb.service_estimate.vehicle_types.vehicle_body_color}))
     
    }
 },
};
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
  font-size: 0.8rem;
}
</style>
